import {useEffect, useState} from 'react';
import {PieChart} from '../components/PieChart';
import {Grid} from '@mui/material';
import {useEstadisticasDsKey} from '../hooks/useEstadisticasDsKey';
import {dataPieChar} from '../../utils/types/pieChart.types';
import { mapperEstadoLlavesToDataPieChar } from '../../utils/mappers/mapperEstadoLlavesToDataMultiChar';
import { useStylesBorder } from '../../utils/styles/styles';
interface LlavesChartProps {
   fecha: Date
}

const categorias = {
   anulado: 'Anuladas',
   nuevo: 'Nuevas',
   vigente: 'Vigentes',
   expirado: 'Expiradas'
};

export const LlavesPorEstado: React.FC<LlavesChartProps> = ({fecha}) => {
   const {classes} = useStylesBorder();
   const [dataChart, setDataChart] = useState<dataPieChar[]>([]);
   const {getEstadoLlavesAnual} = useEstadisticasDsKey();

   const fetchLEstadosLlaves = async () => {
      const result = await getEstadoLlavesAnual({fecha: fecha});
      if (result) {
         const estadoLlaveAnual: dataPieChar[] = mapperEstadoLlavesToDataPieChar({data: result});
         setDataChart(estadoLlaveAnual);
      }
   };

   useEffect(() => {
      fetchLEstadosLlaves();
   }, []);

   return (
      <Grid container className={classes.border}>
         <PieChart
            title="Llaves por Estado"
            data={dataChart}
            categories={categorias}
            defaultSlider={{end: fecha.getMonth(), start: 0}}
         />
      </Grid>
   );
};
